// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"441":"ddeb0249","488":"24ee230c","749":"2ca85d76"}[chunkId] + ".chunk.js";
};